import { COLOR_VARIANTS, Typography, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';
import Styled from './AirlineLogo.styled';

// utils
import _map from 'lodash/map';
import _size from 'lodash/size';
import { useTranslation } from 'react-i18next';

export type AirlineLogoProps = {
  logos: string[];
  operatedByAirlinesText?: string;
  operatedByAirlineLogo?: string;
  testId?: string;
  isFlightDetails?: boolean;
  isSmall?: boolean;
  hasTooltip: boolean;
};

function AirlineLogo({
  logos,
  operatedByAirlineLogo,
  operatedByAirlinesText,
  isFlightDetails,
  testId,
  isSmall = false,
  hasTooltip,
}: AirlineLogoProps): JSX.Element {
  const { t } = useTranslation();
  const Wrapper = _size(logos) > 1 && hasTooltip ? Styled.TooltipWrapper : Styled.Wrapper;
  const options =
    _size(logos) > 1
      ? {
          title: (
            <Typography align="center" variant={TYPOGRAPHY_VARIANT.BODY2} component="p" color={COLOR_VARIANTS.WHITE}>
              {t('SearchResults.AirlinesPartiallyOperated', { flights: operatedByAirlinesText })}
            </Typography>
          ),
        }
      : {};

  const logoSize = isSmall ? '32px' : '40px';

  if (_size(logos) >= 3) {
    return (
      // @ts-ignore - Tooltip has a title prop that expect anyting, but we need to expose to a React element
      <Wrapper {...options} placement="top">
        <div>
          <Styled.AirlineLogosWrapper>
            <Styled.AirlineLogo
              $isFlightDetails={isFlightDetails}
              alt="airline logo"
              src={logos[0]}
              sx={{ height: logoSize, width: logoSize }}
            />

            <Styled.AirlineLogoPlus style={{ height: logoSize, width: logoSize }}>
              <Typography testId={testId} variant={TYPOGRAPHY_VARIANT.CAPTIONREG} component="p">
                +{_size(logos) - 1}
              </Typography>
            </Styled.AirlineLogoPlus>
          </Styled.AirlineLogosWrapper>

          {operatedByAirlineLogo && (
            <Styled.MarketingAirlineLogo
              alt="airline logo"
              src={operatedByAirlineLogo}
              sx={{ height: logoSize, width: logoSize }}
            />
          )}
        </div>
      </Wrapper>
    );
  }

  return (
    // @ts-ignore - Tooltip has a title prop that expect anyting, but we need to expose to a React element
    <Wrapper {...options} placement="top">
      <div style={{ zIndex: 1 }}>
        <Styled.AirlineLogosWrapper>
          {_map(logos, (logo, index) => (
            <Styled.AirlineLogo
              sx={{ height: logoSize, width: logoSize }}
              $isFlightDetails={isFlightDetails}
              key={`Airline-${logo}}-${index}`}
              alt="airline logo"
              src={logo}
            />
          ))}
        </Styled.AirlineLogosWrapper>

        {operatedByAirlineLogo && (
          <Styled.MarketingAirlineLogo
            alt="airline logo"
            src={operatedByAirlineLogo}
            sx={{ height: logoSize, width: logoSize }}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default AirlineLogo;
